import { AMOY } from '../types';
export default {
  type: AMOY,
  service: 'myetherwallet.com-ws',
  url: 'wss://nodesmw.mewapi.io/ws/amoy',
  port: 443,
  auth: false,
  username: '',
  password: ''
};
